import React, { Component, Fragment } from 'react';
import Livescore from '../Livescore';
import Hero from '../Hero';
import Intro from '../../chapters/Intro';
import Chapter1 from '../../chapters/Chapter1';
import Chapter2 from '../../chapters/Chapter2';
import Chapter3 from '../../chapters/Chapter3';
import Chapter4 from '../../chapters/Chapter4';
import Chapter5 from '../../chapters/Chapter5';
import Chapter6 from '../../chapters/Chapter6';
import Chapter7 from '../../chapters/Chapter7';
import Results from '../../chapters/Results';
import Footer from '../../chapters/Footer';
import tracking from '../../services/tracking';

class App extends Component {
  track(id, choice = undefined, score) {
    const name =  choice ? `hoofdstuk.${id}.scenario` : `hoofdstuk.${id}`;
    const section = id;
    const title = choice || score;

    tracking.track(name, section, title);
  }

  render() {
    return (
      <Fragment>
        <Hero text="Jouw gedrag als rapportcijfer" />
        <Intro trackEvent={this.track} id="intro" />
        <Chapter1 trackEvent={this.track} id="1" />
        <Chapter2 trackEvent={this.track} id="2" />
        <Chapter3 trackEvent={this.track} id="3" />
        <Chapter4 trackEvent={this.track} id="4" />
        <Chapter5 trackEvent={this.track} id="5" />
        <Chapter6 trackEvent={this.track} id="6" />
        <Chapter7 trackEvent={this.track} id="7" />
        <Results trackEvent={this.track} id="eindscore" />
        <Footer trackEvent={this.track} id="footer" />
        <Livescore />
      </Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js